import { PROGRESS_ESTIMATE_DELAY } from 'FRONTEND/utils/constants';

export const postForm = async({ data, url, csrfToken, onProgress = () => {} }) => new Promise((resolve, reject) => {
  const requestStart = new Date();

  const request = new XMLHttpRequest();
  request.open('POST', url, true);
  request.setRequestHeader('Accept', 'application/json');
  request.withCredentials = true;
  if (csrfToken) {
    request.setRequestHeader('X-CSRF-Token', csrfToken);
  }

  request.upload.addEventListener('progress', (event) => {
    if (event.lengthComputable) {
      // Progress percentage
      const loaded = event.loaded;
      const total = event.total;
      const progress = (loaded / total) * 100;

      // Time remaining
      const secondsElapsed = (new Date().getTime() - requestStart.getTime()) / 1000;
      const bytesPerSecond = secondsElapsed ? loaded / secondsElapsed : 0;
      const remainingBytes = total - loaded;
      const secondsRemaining = secondsElapsed && secondsElapsed > PROGRESS_ESTIMATE_DELAY ? remainingBytes / bytesPerSecond : 'calculating';
      onProgress({ progress, secondsRemaining });
    }
  }, false);

  request.onload = function() {
    try {
      resolve(JSON.parse(this.response));
    } catch (err) {
      reject(err);
    }
  };

  request.onerror = (jqXHR, textStatus, errorThrown) => {
    reject(errorThrown);
  };

  request.onreadystatechange = () => {
    if (request.readyState === XMLHttpRequest.DONE) {
      const status = request.status;
      if (status !== 0 && (status < 200 || status >= 400)) {
        reject(new Error(`Error uploading form, status ${status}`));
      }
    }
  };

  request.send(data);
});
